import { Injectable, EventEmitter } from '@angular/core';
export const SecurityRoles = 'security-roles';
export const SecurityGroups = 'security-groups';

/**
 * This class is used as an indirection layer for updating the user.
 * This is not a singleton service to protect the global user, only
 * the specific service maintained by the user can update the user objects.
 */
@Injectable()
export class UserManagementService {
  private static seed: number = 0;
  
  public readonly onPropertiesUpdated: EventEmitter<Map<string, any> | null> = new EventEmitter<Map<string, any> | null>();

  /**
   * The instance seed is used to ensure non-singleton functionality
   */
  private readonly instanceSeed: number = -1;

  constructor() {
    this.instanceSeed = UserManagementService.seed++;
  }

  public updateUser(properties: Map<string, any> | null): void {
    console.debug('User Management Service [' + this.instanceSeed + '] - Updating User: ', properties);
    this.onPropertiesUpdated.emit(properties);
  }
}